import { useParticipants } from '@livekit/components-react';

import { isAgentParticipant } from '../lib/isAgentParticipant';

/**
 * Same shape as `useParticipants()` from `@livekit/components-react`,
 * but with LiveKit AGENT-kind participants filtered out. Use this anywhere
 * the UI enumerates "who's in the call" — drawer rosters, counters, audio
 * lists. The transcription bot is an AGENT participant and must never
 * surface to either party.
 */
export function useHumanParticipants(): ReturnType<typeof useParticipants> {
  return useParticipants().filter((p) => !isAgentParticipant(p));
}
